__turbopack_context__.v({
  "className": "dancing_script_a02df474-module__De6ZEq__className",
});
